import { getMessaging, getToken } from 'firebase/messaging';
import { getFromStorage, setToStorage } from '../helpers/storage';
import { app } from '../utils/firebaseKeys';
import { STORAGE_KEYS } from '../constants/storageKeys';

const firebaseCloudMessaging = {
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === 'granted') {
        const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const fcm_token = await getToken(messaging, {
          vapidKey:
            'BBPvOQ9IrlnK6HKzmLCYIeDiqvi9ApEQYkryfByXpARrN-EqMfZzn-hxFDtFwMIsOAhGEqz2pxkjU_ZZKiCFKKM',
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.warn('Notification permission not granted.');
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
